import consumer from "./consumer"
import { router } from '@inertiajs/react'

export const createRefreshChannel = (except = [], channel = "RefreshChannel") => {
	return consumer.subscriptions.create({ channel: channel }, {
		connected() {
			// Called when the subscription is ready for use on the server
			console.log("RefreshChannel connected");
		},

		disconnected() {
			window.cable.subscriptions.consumer.disconnect();
		},

		received(data) {
			console.log("RefreshChannel received data:", data);
			if (data.refresh) {
				router.visit(window.location.href, {
					except: except || [],
				})
			}
		}
	})
}

